import { Menu, Ticket } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { useState } from "react";
import clsx from "clsx";
import { Sidebar } from "./UserSideBar";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/MobileToolTip";
import { User } from "lucide-react";
interface HeaderProps {
  userName: string;
  className?: string;
  userId: number;
}


// Define route-based header content (React components / JSX)
const routeContent: Record<string, JSX.Element> = {
  "/user/ticket-listing": (
    <div className="text-primary gap-2 font-bold text-lg flex items-center">
      <Ticket /> My Tickets
    </div>
  ),
  "/user/profile": (
    <div className="flex items-center gap-2">
      <span className="text-lg font-semibold text-primary">
        👤 User Profile
      </span>
      <span className="text-gray-500 text-sm">(Manage your info)</span>
    </div>
  ),
  "/user/userticketdetail": (
    <div className="text-lg font-bold text-primary flex gap-2 items-center">
      {" "}
      <Ticket className="text-primary" />
      Ticket Details
    </div>
  ),
  "/user/feedback": (
    <div className="text-lg font-bold text-primary flex gap-2 items-center">
      <Ticket className="text-primary" />
      Ticket Feedback
    </div>
  ),
  "/user/edit-profile": (
    <div className="text-lg font-bold text-primary flex gap-2 items-center">
      <User className="text-primary" />
      Your Profile
    </div>
  ),
  "/user/service": (
    <div className="text-lg font-bold text-primary flex gap-2 items-center">
      Department Services
    </div>
  ),
};
export function UserHeader({ userName, className,userId }: Readonly<HeaderProps>) {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
  const navigate=useNavigate();
  const location = useLocation();

  
  const headerContent = Object.entries(routeContent).find(([key]) =>
    location.pathname.startsWith(key)
  )?.[1] || (
    <div>
      <h1 className="text-sm md:text-xl font-semibold sm:text-3xl lg:text-2xl">
        <span className="text-primary font-bold">Welcome,</span> {userName}
      </h1>
      <h1 className="text-xs md:text-xl font-semibold sm:text-3xl lg:text-2xl">
        <span className="font-normal text-gray-400">
          Generate your tickets hassle-free
        </span>
      </h1>
    </div>
  );


  return (
    <div className={clsx("mb-4  top-0 border-b-2 w-full", className)}>
      {/* Header content */}
      <div className="flex items-center justify-between p-4">
       <div>{headerContent}</div>
      
        <div className="flex items-center gap-2  ">
          <Button
            variant="ghost"
            size="icon"
            className="bg-secondary rounded-full"
            onClick={()=>navigate("/user/ticket-listing")}
          >
            <Ticket className="h-5 w-5 text-primary" />
          </Button>
          <Button
            onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
            variant="ghost"
            size="icon"
            className="bg-secondary rounded-full"
          >
            <Menu className="h-5 w-5 text-primary" />
          </Button>
        </div>
      </div>

     
      <Sidebar
        isCollapsed={isSidebarCollapsed}
        setIsCollapsed={setIsSidebarCollapsed}
        userId={userId}
      />
    </div>
  );
}
